exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "payment-notice .text-left{text-align:left;font-family:Roboto,sans-serif}payment-notice .app_logo_notify{width:110px}payment-notice .notify_copy{font-family:Roboto,sans-serif;text-align:justify;margin-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/payment-notice/payment-notice.scss
// module id = 1398
// module chunks = 0